<template>
  <div class="landing-page-body">
    <Toast/>

    <div class="landing-page-panel"></div>

    <div class="landing-page-content" :style="($vssWidth > 767 && $vssWidth < 1800 ? 'width: 47%' : '')">
      <img class="animation" src="assets/layout/images/logo-coface-RVB.png" alt="logo-coface-RVB" style="margin-bottom: 2em"/>

      <h1 class="animation"><span>{{ $t("landingPage.title1") }}</span>{{ $t("landingPage.title2") }}</h1>
      <p class="animation">{{ $t("landingPage.subtitle") }}</p>

      <div class="col-12" style="max-width: 60em;">
        <Button v-if="user.selectioEnabled" :disabled="loading" :label="$t('common.enterSelectio')"
                class="button-landing selectio animation" icon="pi pi-angle-right" icon-pos="right" @click="openSelectio()"/>
        <Button v-if="user.cofastEnabled" :disabled="loading" :label="$t('common.enterCofast')"
                class="button-landing cofast animation" icon="pi pi-angle-right" icon-pos="right" @click="openCofast()"/>
        <Button v-if="user.lensEnabled" :disabled="loading" :label="$t('common.enterLens')"
                class="button-landing lens animation" icon="pi pi-angle-right" icon-pos="right" @click="openLens()"/>
        <Button v-if="user.databrainEnabled" :disabled="loading" :label="$t('common.enterNettuno')"
                class="button-landing nettuno animation" icon="pi pi-angle-right" icon-pos="right" @click="openNettuno()"/>
      </div>
      <div v-if="loading" style="max-width: 60em;" class="col 12">
        <div style="width: 60%; text-align:center">
          <ProgressBar class="custom-progress-bar" mode="indeterminate" style="height: 3px;"></ProgressBar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueScreenSizeMixin } from 'vue-screen-size';
import gsap from "gsap";

export default {
  name: "LandingPage",
  mixins: [VueScreenSizeMixin],

  created() {
    const action = localStorage.getItem('selectio-action');
    if (action === 'go-to-selectio') {
      localStorage.removeItem('selectio-action');
      this.$endpoints.goToSelectio(this.user, this.$router, this.$store, this);
    }
  },

  mounted() {
    gsap.from('.animation', {
      duration: 0.5,
      scale: 0,
      x: 200,
      ease: 'power1',
      stagger: {
        each: 0.1,
        from: 'left'
      }
    });
  },

  computed: {
    user() { return this.$store.getters["user"]; },
    loading() { return this.$store.getters["loading"]; }
  },

  methods: {
    openSelectio() {
        localStorage.setItem('selectio-action', 'go-to-selectio');
        const url = `${window.location.origin}/Selectio/#/`;
        window.open(url, '_blank', 'noopener,noreferrer');
    },

    openCofast() {
      const url = window.__APP_CONFIG__?.selectio_cofast_url;
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },

    openLens() {
      const url = window.__APP_CONFIG__?.selectio_lens_url;
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },

    openNettuno() {
      const url = window.__APP_CONFIG__?.nettuno_url;
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "public/assets/sass/overrides/layout_variables";
.button-landing{ margin-top: 1em; width: 60%; height: 3em}
.selectio{ background: $blue1 }
.cofast{ background: $blue3 }
.lens{ background: $green1 }
.nettuno{ background: $mauve1 }
.p-button:enabled:hover {
  background: $blue5;
  color: $blue1;
}
</style>
